// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_19-7";
export var adjustableWidthBorderHeld = "_19-8";
export var arrow = "_19-3";
export var arrowButton = "_19-4";
export var headerCell = "_19-0";
export var help = "_19-2";
export var icon = "_19-1";
export var iconWrapper = "_19-6";
export var noBorder = "_19-b";
export var nonAdjustableWidthBorder = "_19-9";
export var nonAdjustableWidthBorderHeld = "_19-a";
export var textButton = "_19-5";